import axios from "axios";

// Configure axios defaults
axios.defaults.timeout = 30000;

// Response interceptor to handle blob download errors gracefully
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle blob response errors
    if (error.response?.data instanceof Blob && error.response?.data?.type === "application/json") {
      try {
        const text = await error.response.data.text();
        const parsed = JSON.parse(text);
        error.message = parsed.detail || parsed.message || "Bir hata oluştu";
      } catch {
        // Keep original error
      }
    }
    
    // Suppress console errors for handled cases
    if (error.config?.responseType === "blob" && error.response?.status === 404) {
      // Don't throw - let the component handle it
      return Promise.resolve({ 
        status: error.response.status, 
        data: new Blob([JSON.stringify({ detail: "Dosya bulunamadı" })], { type: "application/json" })
      });
    }
    
    return Promise.reject(error);
  }
);

export default axios;
